import "./style.scss";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import ProjectResourceItem from "../../components/ProjectResourceItem";
import { mainButton } from "@telegram-apps/sdk";
import { useEffect, useState } from "react";
import ProjectResourceCartItem from "../../components/ProjectResourceCartItem";
import { Product } from "../../redux/types/Product";
import { useTariffAddProductsMutation } from "../../redux/api";
import { navigateToPage } from "../../redux/slices/windowSlice";

const ProjectChangeResources = () => {
    const dispatch = useAppDispatch();

    const { products, selectedProducts, projectId } = useAppSelector(
        (state: RootState) => state.windowSlice
    );

    const [loading, setLoading] = useState(true);
    const [totalSum, setTotalSum] = useState(0);

    const [addToTariff, {data, isLoading, isError}] = useTariffAddProductsMutation();

    const handleAddToCart = () => {
        addToTariff({project_id: projectId, products: selectedProducts.selected_product_items});
    }

    const calculate = (C10: number, D10: number, F2: number): number => {
        if (C10 === 0) return 0;

        const sequence = Array.from({ length: C10 }, (_, i) => 1 + i * F2);
        const sum = sequence.reduce((acc, value) => acc + D10 / value, 0);

        return sum;
    };

    useEffect(() => {
        if (!isLoading && data && !isError) {
            dispatch(navigateToPage("resources_cart"));
        } 
    }, [data, isError, isLoading]);

    useEffect(() => {
        mainButton.mount();
        mainButton.setParams({
            backgroundColor: "#3D88F7",
            hasShineEffect: true,
            isEnabled: true,
            isLoaderVisible: false,
            isVisible: false,
            text: "Оплатить",
            textColor: "#ffffff",
        });
        mainButton.onClick(() => {
            // dispatch(setProjectId(projectResources.project_id));
            // dispatch(navigateToPage("resources"));
            mainButton.setParams({
                isLoaderVisible: loading,
            });
            setLoading(!loading);
        });

        return () => {
            mainButton.setParams({
                isVisible: false,
            });
            mainButton.unmount();
        };
    }, []);

    useEffect(() => {
        let newTotalSum = 0;
        selectedProducts.selected_product_items.forEach((product) => {
            const { product_item_id, count } = product;
            let amount = 0;
    
            products.forEach((product) => {
                const item = product.items.find((item) => item.id === product_item_id);
                if (item) {
                    amount = item.amount;
                }
            });
    
            newTotalSum += calculate(count, amount, 0.45);
        });
        setTotalSum(newTotalSum);
    
        if(selectedProducts.selected_product_items.length === 0) {
            mainButton.setParams({
                isVisible: false,
            });
            return;
        }

        if(isLoading) {
            mainButton.setParams({
                isLoaderVisible: true,
            });
            return;
        }

        mainButton.setParams({
            backgroundColor: "#3D88F7",
            hasShineEffect: true,
            isEnabled: true,
            isLoaderVisible: false,
            isVisible: true,
            text: `В корзину • ${newTotalSum.toFixed(2)} EUR`,
            textColor: "#ffffff",
        });

        mainButton.onClick(() => {
            handleAddToCart();
        });

        mainButton.offClick(() => {
            handleAddToCart();
        });

    }, [selectedProducts, isLoading]);

    return (
        <div className="project-change-resources">
            <div className="project-change-resources_container">
                <div className="project-change-resources_wrapper">
                    {products.map((product: Product) => (
                        <ProjectResourceCartItem
                            key={product.id}
                            product={product}
                        />
                    ))}
                    <button className="pay" onClick={handleAddToCart}>
                        PAY {totalSum.toFixed(2)}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProjectChangeResources;
